import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface SliderItem {
  logo: string;
}

interface SliderProps {
  title: string;
  description: string;
  slides: SliderItem[];
}

const LogoSlider: React.FC<SliderProps> = ({ title, description, slides }) => {
  const settings = {
    className: "w-auto",
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",

    // pauseOnHover: false,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          dots: false,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          speed: 500,
          autoplaySpeed: 2000,
          pauseOnHover: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          dots: false,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: true,
          speed: 500,
          autoplaySpeed: 2000,
          pauseOnHover: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          speed: 500,
          autoplaySpeed: 2000,
          pauseOnHover: false,
        },
      },
    ],
  };

  return (
    <div className="w-full cursor-default pt-12">
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-10">
        <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent text-3xl lg:text-4xl font-extrabold drop-shadow-lightBlue uppercase">
          {title}
        </span>
        <p className="w-full text-dark/50 text-base lg:text-lg text-justify font-normal leading-6 my-6">
          {description}
        </p>
      </div>
      <div className="overflow-hidden">
        <Slider {...settings}>
          {slides.map((item, index) => (
            <div
              key={index}
              className={`h-auto px-10 py-4 xl:py-8 ${
                index % 2 === 0 ? "bg-sky" : "bg-gray"
              }`}
            >
              <div className="w-full h-24 p-4 flex justify-center items-center">
                <img src={item.logo} alt="LOGO" className="w-full h-full" />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default LogoSlider;
